<app-content>
  <app-breadcrumbs>
    <li>
      <a routerLink='/wnioski-zatwierdzone' aria-label='Wnioski zatwierdzone'>
        Wnioski zatwierdzone
      </a>
    </li>
    <li>
      {{ serviceType()?.name }}
    </li>
  </app-breadcrumbs>
  <section>
    <br>
    <app-alert-container [dismissible]='false'></app-alert-container>
    @if (!loading()) {
      <div class="row">
        <div class='col-12'>
          <app-payment-status-checker
            *ngIf='paymentToken'
            (completed)='onPaymentComplete()'
            [closableAlert]='false'
            [paymentToken]='paymentToken'
            [canDownload]='false'>
          </app-payment-status-checker>
        </div>
        <div class="col-12">
          <div class='download-actions' *ngIf='application()'>
            <a href='#' title='Pobierz PDF' class='btn btn-secondary' (click)='onDownloadApplicationPdf($event)'>
              <i aria-hidden='true' class='fa fa-file-download'></i>
              Pobierz wniosek PDF
            </a>
          </div>
        </div>
      </div>
      <h2>
        {{ serviceType()?.name }}
      </h2>
      <app-carrying-out-works-preview
        *ngIf="contentUrl === 'zajecie-pasa-prowadzenie-robot'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-carrying-out-works-preview>
      <app-location-reconstruction-of-exit-preview
        *ngIf="contentUrl === 'lokalizacja-przebudowa-zjazdu'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-location-reconstruction-of-exit-preview>
      <app-notification-of-emergency-preview
        *ngIf="contentUrl === 'awaryjne-zajecie-pasa-drogowego'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-notification-of-emergency-preview>
      <app-location-of-devices-unrelated-to-road-preview
        *ngIf="contentUrl === 'umieszczenie-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-location-of-devices-unrelated-to-road-preview>
      <app-localisation-devices-unrelated-to-road-preview
        *ngIf="contentUrl === 'lokalizacja-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-localisation-devices-unrelated-to-road-preview>
      <app-approval-of-traffic-organization-projects-preview
        *ngIf="contentUrl === 'zatwierdzenie-projektow-organizacji-ruchu-dla-drog-wewnetrznych'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-approval-of-traffic-organization-projects-preview>
      <app-opinion-on-the-project-of-traffic-org-preview
        *ngIf="contentUrl === 'opinia-do-projektu-organizacji-ruchu-dla-drog-publicznych'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-opinion-on-the-project-of-traffic-org-preview>
      <app-placement-advertising-preview
        *ngIf="contentUrl === 'umieszczenie-reklamy'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-placement-advertising-preview>
      <app-compensation-for-losses-preview
        *ngIf="contentUrl === 'odszkodowanie-za-straty'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-compensation-for-losses-preview>
      <app-opinion-on-issuing-a-decision-preview
        *ngIf="contentUrl === 'opinia-w-sprawie-wydania-decyzji'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-opinion-on-issuing-a-decision-preview>
      <app-public-information-disclosure-preview
        *ngIf="contentUrl === 'udostepnienie-informacji-publicznej'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-public-information-disclosure-preview>
      <app-notification-general-remarks-road-marking-preview
        *ngIf="contentUrl === 'zgloszenie-uwagi-ogolne-oznakowanie-drog'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-notification-general-remarks-road-marking-preview>
      <app-consent-reconstruction-renovation-of-buildings-preview
        *ngIf="contentUrl === 'zgoda-przebudowa-remont-obiektow-budowlanych'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-consent-reconstruction-renovation-of-buildings-preview>
      <app-documents-information-preview
        *ngIf="contentUrl === 'uzupelnienie-dokumentow'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-documents-information-preview>
      <app-general-letter-preview
        *ngIf="contentUrl === 'pismo-ogolne'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-general-letter-preview>
      <app-response-to-call-preview
        *ngIf="contentUrl === 'odpowiedz-na-wezwanie'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-response-to-call-preview>
      <app-occupation-of-lane-placement-construction-objects-preview
        *ngIf="contentUrl === 'zajecie-pasa-umieszczenie-obiektow-budowlanych'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-occupation-of-lane-placement-construction-objects-preview>
      <app-take-over-lane-reconstruction-of-exit-preview
        *ngIf="contentUrl === 'zajecie-pasa-budowa-przebudowa-zjazdu'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-take-over-lane-reconstruction-of-exit-preview>
      <app-permit-for-oversize-vehicles-preview
        *ngIf="contentUrl === 'zezwolenie-przejazdy-pojazdow-nienormatywnych'"
        [canPay]='canPay'
        [shipments]='shipments()'
        [application]='application()'>
      </app-permit-for-oversize-vehicles-preview>
    }
    <ng-container *ngIf='!loading()'>
      <br>
      <div class='application-actions'>
        <button
          type='button'
          class='btn btn-secondary' routerLink='../../'>
          <span>
            Wstecz
          </span>
        </button>
        <button
          *ngIf='!!application()?.signedDocument?.id && !application()?.sentAt'
          [disabled]='pending()'
          (click)='sendApplication()'
          type='button'
          class='btn btn-primary'>
          <span>Wyślij wniosek</span>
        </button>
        @if (!production) {
          <button
            *ngIf='!application()?.signedDocument?.id'
            [disabled]='pending()'
            (click)='fakeSign()'
            type='button'
            class='btn btn-primary'>
            <span>Podpisz wniosek demo</span>
          </button>
        }
        <button
          *ngIf='!application()?.signedDocument?.id'
          [disabled]='pending()'
          (click)='signApplication()'
          type='button'
          class='btn btn-primary'>
          <span>Podpisz wniosek</span>
        </button>
      </div>
    </ng-container>
    <app-spinner *ngIf='loading()'>
      Poczekaj trwa ładowanie danych...
    </app-spinner>
  </section>
</app-content>
